import React from 'react';
import PropTypes from 'prop-types';

const Pg = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.9">
      <path
        d="M18.6595 12.1167V16.8243C18.6595 18.1173 17.607 19.1671 16.3108 19.1671H15.7014C16.2664 19.1671 16.3108 17.5647 16.3108 16.8243V14.4595C16.3108 13.8185 16.5767 13.2328 16.9977 12.8018C17.4297 12.3819 18.0169 12.1167 18.6595 12.1167Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M7.86823 1.37451C7.86823 2.66746 6.81573 3.71729 5.51949 3.71729H3.18182V4.08196C3.18182 4.08196 3.04887 1.37451 3.78008 1.37451H7.86823Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M15.7123 19.1664H0.833252V3.71729C0.833252 2.42434 1.88576 1.37451 3.182 1.37451H3.78027C3.04905 1.37451 3.182 4.08197 3.182 4.08197V16.8236H16.3217C16.3217 17.564 16.2663 19.1664 15.7123 19.1664Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M10.5826 1.38623C10.5716 1.39728 10.5605 1.39728 10.5383 1.39728C10.5716 1.38623 10.5826 1.38623 10.5826 1.38623Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M12.9649 4.65705L12.9539 4.646C12.9649 4.646 12.9649 4.65705 12.9649 4.65705Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M1.98552 7.22119L2.01876 7.25434C1.95228 7.25434 1.88581 7.26539 1.81934 7.2875C1.91905 7.23224 1.98552 7.22119 1.98552 7.22119Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M19.9999 5.78397L12.2667 13.4975C11.4247 14.3373 10.0731 14.3373 9.2311 13.4975L8.45557 12.7239C9.18678 13.4533 10.7378 11.6962 10.7378 11.6962L16.6651 5.78397L14.128 3.25333C14.128 3.25333 15.6902 1.49625 16.4103 2.2256L19.9999 5.78397Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.46676 12.7131L4.9104 9.16582L12.6325 1.46339C13.4745 0.62353 14.8261 0.62353 15.6681 1.46339L16.4326 2.2259C15.7013 1.49655 14.1503 3.25363 14.1503 3.25363L8.22302 9.16582L10.749 11.6854C10.749 11.6854 9.18689 13.4425 8.46676 12.7131Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
  </svg>
);

Pg.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Pg;
